module.exports = __webpack_public_path__ + "static/media/ToS.eeab20ba.pdf";